import { Flex } from '@chakra-ui/react';
import { format } from 'date-fns';

import { Calendar } from 'assets/assetsV1/iconComponents';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

export const ReadOnlyCalendarInput = ({ selectedDate }) => {
  const formattedDate = format(selectedDate, 'MMM dd, yyyy');
  return (
    <Flex h="40px" alignItems="center" p={2} pl={0}>
      <Calendar color="#666666" boxSize="24px" />
      <TextBodyMedium color="#333333" mx={2}>
        {formattedDate}
      </TextBodyMedium>
    </Flex>
  );
};
